<!-- //
数据服务-api详情
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-form @submit.native.prevent :model="form" size="small" label-width="120px" class="form">
    <el-form-item>
      <span slot="label" class="title">接口名</span>
      <span>{{ form.apiName }}</span>
    </el-form-item>
    <el-form-item prop="apiComment">
      <span slot="label" class="title">接口名称(中文)</span>
      <span>{{ form.apiComment }}</span>
    </el-form-item>
    <el-form-item>
      <span slot="label" class="title">接口描述</span>
      <span>{{ form.apiDesc }}</span>
    </el-form-item>
    <el-form-item>
      <span slot="label" class="title">设计人</span>
      <span>{{ form.designUserName }}（{{ form.designUser }}）</span>
    </el-form-item>
    <el-form-item>
      <span slot="label" class="title">API路径</span>
      <span>{{ form.apiPath }}</span>
    </el-form-item>
    <el-row class="flow-row">
    </el-row>
  </el-form>
</template>

<script>

export default {
  name: 'CompApiDesignDetail',
  dictTypes: [],
  data() {
    return {
      loading: false,
      form: this.formData,
    }
  },
  props: {
    formData: Object
  },
  watch: {
    formData (val) {
      this.form = val
    },
  }
}
</script>

<style lang="less" scoped>
.form {
  .title {
    font-weight: 650;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
